<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center align-items-center">
      <b-spinner
        variant="primary"
        class="text-center"
      />
    </div>
    <b-card v-else-if="!loading && holdingTransaccionality" class="w-100" header-tag="header">
      <template #header>
        <div class="w-100 d-flex flex-column">
          <div class="d-flex justify-content-between">
            <h4>
              {{holdingTransaccionality.razonSocial}}
              <small class="ml-3">{{holdingTransaccionality.cliente}}</small>
            </h4>
            <div>
              <vs-icon
                icon="file_download"
                class="cursor-pointer mr-5"
                size="small"
                v-tooltip="'Descargar reporte mensual'"
                @click="downloadMonthlyCSV"
              />
              <vs-icon
                icon="file_download"
                class="cursor-pointer"
                size="small"
                v-tooltip="'Descargar reporte operaciones'"
                @click="downloadCSV"
              />
            </div>
          </div>
        </div>
      </template>
      <hr class="p-0 m-0">
      <div class="row">
        <div class="col-lg-12">
          <b-table
            table-class="text-center"
            responsive
            bordered
            caption-top
            :items="transactions"
            :fields="transactionsFields"
          >
            <template #table-caption>
              <h3>Transacciones</h3>
            </template>
            <template #head(monthlyMb)="{ label }">
              <span
                class="cursor-default"
                v-b-tooltip.hover.left="'Pueden haber mínimas variaciones en\
                los totales debido al redondeo aplicado.'"
              >
                {{label}}
              </span>
            </template>
          </b-table>
        </div>
        <div class="col-lg-12">
          <b-table
            table-class="text-center"
            responsive
            bordered
            caption-top
            :items="storage"
            :fields="storageFields"
          >
            <template #table-caption>
              <h3>Almacenamiento</h3>
            </template>
          </b-table>
        </div>
        <div class="col-lg-12">
          <b-table
            table-class="text-center"
            responsive
            bordered
            caption-top
            :items="flow"
            :fields="flowFields"
          >
            <template #table-caption>
              <h3>Aprobaciones</h3>
            </template>
          </b-table>
        </div>
        <div class="col-lg-4">
          <b-table
            table-class="text-center"
            responsive
            bordered
            caption-top
            :items="sign"
            :fields="signFields"
          >
            <template #table-caption>
              <h3>Firmas</h3>
            </template>
          </b-table>
        </div>
        <div class="col-lg-12">
          <div class="text-right">
            <vs-button @click="goBack">Volver</vs-button>
          </div>
        </div>
      </div>
    </b-card>
    <h4 v-else>No hay detalles para esta empresa
      <div class="col-lg-12">
        <div class="text-right">
          <vs-button @click="goBack">Volver</vs-button>
        </div>
      </div>
    </h4>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'HoldingSummary',
  props: ['newFilter'],
  data() {
    return {
      transactionsFields: [
        { key: 'upload', label: 'Carga' },
        { key: 'download', label: 'Descarga' },
        { key: 'update', label: 'Actualización' },
        { key: 'delete', label: 'Eliminación' },
        { key: 'notification', label: 'Notificaciones' },
        { key: 'totalTransactions', label: 'Total Transacciones del Mes' }
      ],
      storageFields: [
        { key: 'file', label: 'Archivos' },
        { key: 'folder', label: 'Carpetas' },
        { key: 'historicStorage', label: 'MB Histórico' },
        { key: 'monthlyStorage', label: 'MB del Mes' },
        { key: 'totalStorage', label: 'MB Total' }
      ],
      otherDataFields: [
        { key: 'email_notifications', label: 'Notificaciones por correo' }
      ],
      flowFields: [
        { key: 'approvedFiles', label: 'Aprobados' },
        { key: 'rejectedFiles', label: 'Rechazados' },
        { key: 'resendedFiles', label: 'Reenviados' },
        { key: 'returnedFiles', label: 'Devueltos' },
        { key: 'flow', label: 'Envíos a flujo' },
        { key: 'totalApprovals', label: 'Total' }
      ],
      signFields: [
        { key: 'signedFiles', label: 'Firmados' }
      ],
      filters: [
        {
          name: 'cliente',
          filter: `cliente:${this.$route.params.enterpriseId}`
        },
      ],
      loading: true
    };
  },
  watch: {
    async filters() {
      this.loading = true;
      await this.fetchData();
      this.loading = false;
    },
    newFilter(val) {
      this.setFilter(val.type, val.filter);
    }
  },
  mounted() {
    const { data } = this.$route.params;
    if (data) {
      this.globalData = data;
      console.log('this.globalData::1', this.globalData, data);
    }
  },
  computed: {
    ...mapGetters('Operations', ['holdingTransaccionality']),
    transactions() {
      console.log('this.globalData::2', this.globalData);
      return [{
        upload: this.globalData.transactions.carga,
        download: this.globalData.transactions.descarga,
        update: this.globalData.transactions.actualizacion,
        delete: this.globalData.transactions.eliminacion,
        notification: this.globalData.transactions.notificacion,
        totalTransactions: this.globalData.transactions.total,
      }];
    },
    storage() {
      return [{
        file: this.globalData.transactions.archivos,
        folder: this.globalData.transactions.carpetas,
        historicStorage: this.globalData.storage.historico,
        monthlyStorage: this.globalData.storage.totalMes,
        totalStorage: this.globalData.storage.total
      }];
    },
    flow() {
      return [{
        approvedFiles: this.globalData.approvals.aprobados,
        rejectedFiles: this.globalData.approvals.rechazados,
        resendedFiles: this.globalData.approvals.reenviados,
        returnedFiles: this.globalData.approvals.devueltos,
        flow: this.globalData.approvals.envioFlujo,
        totalApprovals: this.globalData.approvals.total

      }];
    },
    sign() {
      return [{
        signedFiles: this.globalData.totalSigns
      }];
    }
  },
  methods: {
    ...mapActions('Operations', ['getHoldingTransaccionality']),
    async fetchData() {
      await this.getHoldingTransaccionality({
        params: {
          filtros: this.filters.map((f) => f.filter).join('|')
        }
      });
    },
    setFilter(type, filter) {
      this.filters = this.filters.filter((f) => f.name !== type);
      if (filter === '*') return;
      this.filters.push({
        name: type,
        filter
      });
    },
    downloadCSV() {
      window.open(this.globalData.detailReport);
    },
    downloadMonthlyCSV() {
      window.open(this.globalData.monthlyReport);
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  async created() {
    this.setFilter(
      'periodo', `periodo:${this.$moment(new Date()).subtract(1, 'months').format('YYYY-MM')}`
    );
    this.loading = false;
  }
};
</script>
